import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { getJwtToken } from "../../storage/user";
import { isFeatureExcluded, isRouteAllowed } from "../../utils/commonUtils";
import AlertService from "../common/Alert/alertService";
import ComingSoon from "../common/ComingSoon";
import Layout from "../Layout";
import Unauthorize from "../Unauthorize";
import { DashBoardRoute, OnBoardingRoute, SignInRoute } from "./routes";

const PrivateRoute = () => {
  const { warning } = AlertService();
  const location = useLocation();
  const token = getJwtToken();
  const { role, yourDetails, selectPlan, termsAndConditions, paymentSetup, displayCongrats } = useSelector(
    (state) => state.user
  );

  const isOnboarded = yourDetails && selectPlan && termsAndConditions && paymentSetup && !displayCongrats;
  const { isPublicRoute, isPrivateRoute } = isRouteAllowed(location.pathname, role);

  useEffect(() => {
    const isFirebaseMessagingSupported = localStorage.getItem("isFirebaseMessagingSupported");

    if (isFirebaseMessagingSupported === "false") {
      warning("Please use a supported browser to access Nativus Coach. Support browsers are listed on our website.");
    }
  }, []);

  if (isPublicRoute) {
    if (!token) return <Outlet />;
    if (role && isOnboarded) return <Navigate to={DashBoardRoute} replace />;
  }

  if (isPrivateRoute) {
    if (!isOnboarded) {
      if (location.pathname !== OnBoardingRoute) {
        return <Navigate to={OnBoardingRoute} replace />;
      }
      return <Outlet />;
    }

    if (isFeatureExcluded(location.pathname)) {
      return (
        <Layout>
          <ComingSoon />
        </Layout>
      );
    }

    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  }

  return role ? <Unauthorize /> : <Navigate to={SignInRoute} />;
};

export default PrivateRoute;
